export const helpEn = {
  companySettings: {
    title: '',
    html: ''
  },
  projects: {
    title: '',
    html: ''
  },
  googleCalendar: {
    title: 'Integration with Google Calendar',
    html: `
    Integration with Google Calendar transfers data in only one direction: <b>from YouGile to Google Calendar.</b><br /><br />
    When the integration is enabled, events will be created in the Google calendar based on tasks with a completed <b>Deadline sticker</b>.<br /><br />
    In the settings, you can choose whether to transfer all tasks or only those that are assigned to you.<br /><br />
    Once the integration is enabled, events in Google Calendar will be automatically updated. <br /><br />
    Synchronized:<br />
    <ul>
      <li>task name,</li>
      <li>deadline date,</li>
      <li>path to a task in YouGile,</li>
      <li>performers are indicated in the Google calendar as participants in the event.</li>
    </ul>
    `
  },
  adminProjects: {
    title: '',
    html: ''
  },
  inviteLink: {
    title: '',
    html: ''
  },
  departments: {
    title: '',
    html: ''
  },
  users: {
    title: '',
    html: ''
  },
  mainReport: {
    title: '',
    html: ''
  },
  tablesReport: {
    title: '',
    html: ''
  },
  timelineReport: {
    title: '',
    html: ''
  },
  byUserReport: {
    title: '',
    html: ''
  },
  editRepeatTemplate: {
    title: '',
    html: ''
  },
  createRepeatTemplate: {
    title: '',
    html: ''
  },
  repeatDeadline: {
    title: '',
    html: ''
  },
  partnerReferrals: {
    title: '',
    html: ''
  },
  filterGroup: {
    title: '',
    html: ''
  },
  checklists: {
    title: '',
    html: ''
  },
  taskMirrors: {
    title: '',
    html: ``
  },
  parentTasks: {
    title: '',
    html: ''
  },
  subtasks: {
    title: '',
    html: ''
  },
  userSticker: {
    title: '',
    html: ''
  },
  deadlineSticker: {
    title: '',
    html: ''
  },
  repeatSticker: {
    title: '',
    html: ''
  },
  stopwatchSticker: {
    title: '',
    html: ''
  },
  timerSticker: {
    title: '',
    html: ''
  },
  timetrackingSticker: {
    title: '',
    html: ''
  },
  stringSticker: {
    title: '',
    html: ''
  },
  sprintSticker: {
    title: '',
    html: ''
  },
  textSticker: {
    title: '',
    html: ''
  },
  numericSticker: {
    title: '',
    html: ''
  },
  columnReport: {
    title: '',
    html: `
      We calculated how much time the tasks spent in each column, averaged it and showed it on the graph.
      <br/>
      <br/>
      If the column is red and tall, you should pay attention to it, this is where tasks spend the most time
    `
  },
  boardSettingsAutoTaskCover: {
    title: '',
    html: 'This settings does not change manually assigned task covers'
  },
  totalConversion: {
    title: 'Sales Conversion Funnel',
    html: `
    The conversion funnel shows how deals progressed through each stage of the pipeline.<br /><br />
    Even if a deal was won earlier, it still appears at all stages — this provides a complete picture:<br />
    <ul>
      <li>understanding which stages perform well,</li>
      <li>identifying weak points where clients are lost.</li>
    </ul>
    The "Date created" filter selects deals by their creation date and shows the stage they are currently at.
  `
  },
  managerConersion: {
    title: 'Manager Performance Report',
    html: `
    Shows the sales funnel for a specific assignee: how many deals reached each stage and the conversion percentage between them.
    <br /><br />
    The final success rate is calculated based on the number of that manager's incoming leads.
    <br /><br />
    Date filtering is available to evaluate performance within a selected period.
  `
  },
  conversionRejected: {
    title: 'Rejection Rate',
    html: `
    Shows what percentage of all incoming leads during the selected period ended with a rejection status.
    <br /><br />
    Includes all deals located in the "❌ Rejected" column.
    <br /><br />
    Filtering by date and assignee is available.
  `
  },
  conversionSucceed: {
    title: 'Success Rate',
    html: `
    Shows what percentage of all incoming leads during the selected period were successfully closed.
    <br /><br />
    Includes all deals located in the "✅ Successed" column.
    <br /><br />
    Filtering by date and assignee is available.
  `
  }
}

export const helpRu: typeof helpEn = {
  companySettings: {
    title: 'Настройки компании',
    html: `
    <a href="https://youtu.be/JHFgpmnzKlE" target="_blank" rel="noopener">
      <img src="/img/help/content/01-settings@2x.png" alt="" style="width: 232px;" />
      <img data-hover src="/img/help/content/01-settings-active@2x.png" alt="" style="width: 232px;" />
    </a>
    <br />

    Настройки компании могут редактировать только Администраторы компании.
    <br />
    <b>Определяют базовые возможности и права всех участников.</b>
    <br />
    <br />
    Информация о настройках доступна всем пользователям для просмотра.
    Любой может обратиться к администратору и запросить изменения.
    `
  },
  projects: {
    title: 'Проекты',
    html: `
    <a href="https://youtu.be/l_MoZAhNM9A" target="_blank" rel="noopener">
      <img src="/img/help/content/03-projects@2x.png" alt="" style="width: 232px;" />
      <img data-hover src="/img/help/content/03-projects-active@2x.png" alt="" style="width: 232px;" />
    </a>
    <br />

    Проект — основная единица для управления процессами в компании.
    В одном проекте может быть любое количество досок и участников.
    <br />
    <br />
    Участники имеют роли: Управляющий, Сотрудник, Наблюдатель.
    <b>На досках реализуются</b> самые разные бизнес-процессы:
    от простого создания сайта малой командой
    <b>до строительства жилого квартала управляющей командой из 300 человек</b>.
    <br />
    <br />
    Примеры бизнес-процессов на досках:
    <br />
    <a href="https://www.youtube.com/watch?v=Q3-2m3eiSew" target="_blank" rel="noopener">
      <img src="/img/help/content/10-processes@2x.png" alt="" style="width: 232px;" />
      <img data-hover src="/img/help/content/10-processes-active@2x.png" alt="" style="width: 232px;" />
    </a>
    `
  },
  googleCalendar: {
    title: 'Интеграция с Google-календарем',
    html: `
    Интеграция с Google-календарем передает данные только в одном направлении: <b>из YouGile в Google-календарь.</b><br /><br />
    При включении интеграции, события будут создаваться в Google-календаре на основе задач с заполненным стикером <b>Дедлайн</b>.<br /><br />
    В настройках вы можете выбрать, переносить все задачи или только те, которые назначены на вас.<br /><br />
    После включения интеграции, события в Google-календаре будут автоматически обновляться.<br /><br />
    Синхронизируются:<br />
    <ul>
      <li>название задачи,</li>
      <li>дата дедлайна,</li>
      <li>путь до задачи в YouGile,</li>
      <li>исполнители указываются в Google-календаре, как участники события.</li>
    </ul>
    `
  },
  adminProjects: {
    title: 'Проекты для администрирования',
    html: `
    Вы, как администратор компании, можете просматривать и управлять
    всеми проектами. В этом списке проекты, в которых
    <b>вы не участвуете, но можете вносить любые изменения</b>.
    `
  },
  inviteLink: {
    title: 'Приглашение в компанию по ссылке',
    html: `
    По данной ссылке можно зарегистрироваться в эту компанию.
    <b>Отправьте её коллегам на e-mail или в мессенджере.</b>
    <br />
    После регистрации по ссылке участник будет иметь ограниченный доступ,
    пока его не добавят в проект или отдел.
    <br />
    Изменять ссылку, придумать короткий адрес или удалить может
    только администратор компании.
    `
  },
  departments: {
    title: 'Отделы компании или орг. структура',
    html: `
    Самый важный блок для организации большой команды.
    Здесь можно повторить организационную структуру.
    <br />
    <br />
    Можно создавать отделы и делать их подчиненными друг другу.
    <b>Можно назначать руководителей отделов,
    обеспечивая их правом полностью управлять своим подразделением</b> —
    приглашать сотрудников в отдел, видеть задачи сотрудников,
    создавать проекты, и определять роли участников проекта.
    <br/>
    <br/>
    Подробнее про отделы можно посмотреть в <a href="https://help.yougile.com/books/baza-znanii-yougile/page/otdely-kompanii" target="_blank" rel="noopener">
    базе знаний</a>
    `
  },
  users: {
    title: 'Сотрудники компании',
    html: `
    <a href="https://youtu.be/mEXcxookrhU" target="_blank" rel="noopener">
      <img src="/img/help/content/04-users@2x.png" alt="" style="width: 232px;" />
      <img data-hover src="/img/help/content/04-users-active@2x.png" alt="" style="width: 232px;" />
    </a>
    <br />
    Полный список всех участников компании,
    в котором всегда <b>можно найти нужного человека и написать
    ему личное сообщение</b>.
    <br />
    <br />
    Данный раздел доступен всем участникам компании.
    `
  },
  mainReport: {
    title: 'Общий отчет',
    html: `
    <a href="https://youtu.be/hI1lL8BdItc" target="_blank" rel="noopener">
      <img src="/img/help/content/05-basic-reports@2x.png" alt="" style="width: 232px;" />
      <img data-hover src="/img/help/content/05-basic-reports-active@2x.png" alt="" style="width: 232px;" />
    </a>
    <br />
    Показывает главную информацию по проектам, отделам и сотрудникам.
    Щелчок на любое число в таблице открывает детальную таблицу с задачами.
    <br />
    <br />
    На видео дан пример работы с общим отчетом.
    `
  },
  tablesReport: {
    title: 'Таблицы или выгрузки',
    html: `
    Здесь можно сформировать и выгрузить любую информацию по компании,
    доступную вам с учетом уровня доступа.
    `
  },
  timelineReport: {
    title: 'Лента событий и действий',
    html: `
    Здесь можно вывести действия коллег по доступным вам задачам.
    Удаленные файлы, задачи, колонки и доски можно восстановить.
    <br />
    <br />
    Для работы с инструментом <b>воспользуйтесь фильтрацией</b>.
    Например, отобразите все файлы и картинки, которые загрузили в чаты
    по задачам ваши коллеги.
    `
  },
  byUserReport: {
    title: 'Актуальные задачи сотрудников',
    html: `
    Выводит задачи, которые сейчас открыты у ваших коллег и доступны вам.
    Для работы с инструментом <b>воспользуйтесь фильтрацией</b>.
    Например, наблюдайте за задачами из самого важного для вас проекта.
    `
  },
  editRepeatTemplate: {
    title: 'Редактирование шаблона',
    html:
      'В правой панели вы можете отредактировать шаблон регулярной задачи. ' +
      'Каждая следующая задача будет иметь содержимое шаблона. Это касается ' +
      'описания, подзадач и прикреплённых к задаче стикеров.'
  },
  createRepeatTemplate: {
    title: 'Шаблоны регулярных задач',
    html: `
      <a href="https://youtu.be/onL3a-hAvMk" target="_blank" rel="noopener">
        <img src="/img/help/content/recurrent-tasks@2x.png" alt="" style="width: 232px;" />
        <img data-hover src="/img/help/content/recurrent-tasks-active@2x.png" alt="" style="width: 232px;" />
      </a>
      <br />
      Вы можете создать шаблон, по которому в доске будут автоматически
      создаваться регулярные задачи.
      <br>
      <br>
      После создания шаблона, в нём можно настроить периодичность повторений.
      Можно также заполнить описание, подзадачи, указать стикеры, исполнителей,
      дедлайн – эти параметры будут автоматически устанавливаться на
      создаваемых задачах.
    `
  },
  repeatDeadline: {
    title: 'Дедлайн шаблона регулярной задачи',
    html: `
      В шаблоне регулярной задачи дедлайн указывается для
      ближайшего повторения.
      <br />
      <br />
      Для последующих повторений дата дедлайна будет автоматически смещёна.
      Если вы измените условия повторения, то дедлайн также автоматически
      скорректируется.
    `
  },
  partnerReferrals: {
    title: 'Список компаний рефералов',
    html: `
      Все компании, которые созданы вашими рефералами, становятся
      вашими реферальными компаниями. При оплате лицензии в такой
      компании вы получаете партнёрское вознаграждение – 20% от суммы оплаты.
      <br />
      <br />
      Данные в этой таблице обновляются <b>раз в 10 минут</b>.
    `
  },
  filterGroup: {
    title: 'Группы фильтров',
    html: `
    Вы можете создать несколько групп фильтров, их результаты будут объединены (между группами работает логический оператор "ИЛИ").
    `
  },
  checklists: {
    title: 'Чеклисты',
    html: `
    Чеклисты — упрощенный вариант подзадач, когда не требуется создавать отдельные задачи для каждого пункта и назначать на них исполнителей и дедлайны.
    <br/>
    <br/>
    Чеклисты легко создавать и редактировать, может быть несколько списков с любым кол-вом пунктов.
    <br/>
    <br/>
    Прогресс по чеклистам отображается на задаче на доске, если у задачи нет подзадач (иначе показывается информация по подзадачам).  `
  },
  taskMirrors: {
    title: 'Зеркала задачи',
    html: `
    Зеркало задачи - это синхронизированная копия задачи.
    <br/>
    <br/>
    Создав зеркало, вы получаете идентичные задачи, отличающиеся только ID.
    <br/>
    <br/>
    Если вы изменяете название в одном зеркале - название меняется в другом; чаты, описание, приклеенные стикеры - всё синхронизируется.
    <br/>
    <br/>
    При этом задачи могут находиться в разных проектах и управляться разными людьми, что делает зеркало задачи инструментом онлайн мониторинга.`
  },
  parentTasks: {
    title: 'Родительские задачи',
    html: `
    Здесь отображается список родительских задач. Одна задача может быть дочерней к нескольким родительским задачам.
    `
  },
  subtasks: {
    title: 'Подзадачи',
    html: `
    Подзадачи — это полноценные задачи внутри родительской задачи. Можно создать новую или указать любую задачу из любого проекта в качестве подзадачи. Можно прикреплять ответственных, дедлайн и другие стикеры.
    <br/>
    <br/>
На родительской задаче отображается прогресс выполнения подзадач. Если подзадач нет, то отображается прогресс по чеклистам.
    `
  },
  userSticker: {
    title: 'Стикер «Исполнитель»',
    html: 'Позволяет указывать в задаче исполнителя из числа добавленных в проект.'
  },
  deadlineSticker: {
    title: 'Стикер «Дедлайн»',
    html: 'Позволяет добавлять дедлайн к задачам в доске.'
  },
  repeatSticker: {
    title: 'Стикер «Регулярная задача»',
    html: `
      Ecли добавить этот стикер на задачу, то она будет появляться на доске регулярно. Можно настроить периодичность повторений.
      <br/>
      <br/>
      Пример: еженедельное планирование
    `
  },
  stopwatchSticker: {
    title: 'Стикер «Секундомер»',
    html: 'Позволяет добавлять к задачам секундомер, который можно запускать и останавливать, что позволяет, например, следить за потраченным на задачу временем.'
  },
  timerSticker: {
    title: 'Стикер «Таймер»',
    html: 'Позволяет устанавливать на задачи таймер с обратным отсчётом, который может показывать сколько времени осталось до запланированного завершения задачи.'
  },
  timetrackingSticker: {
    title: 'Стикер «Timetracking»',
    html: 'Добавляет возможность указывать план и факт в задачах на доске.'
  },
  stringSticker: {
    title: '',
    html: ''
  },
  sprintSticker: {
    title: '',
    html: ''
  },
  textSticker: {
    title: '',
    html: ''
  },
  numericSticker: {
    title: '',
    html: ''
  },
  columnReport: {
    title: '',
    html: `
      Мы подсчитали, сколько времени задачи провели в каждой колонке, усреднили это и показали на графике.
      <br/>
      <br/>
      Если колонка красная и высокая - вам стоит обратить на нее внимание, это то место, где задачи проводят больше всего времени
    `
  },
  boardSettingsAutoTaskCover: {
    title: '',
    html: 'Данная настройка не будет заменять загруженные вручную обложки'
  },
  totalConversion: {
    title: 'Конверсионная воронка продаж',
    html: `
    Конверсионная воронка показывает, как сделки проходили через этапы воронки.<br /><br />
    Даже если сделка была выиграна раньше, она всё равно отображается на всех стадиях — это даёт полную картину:<br />
    <ul>
      <li>понимание, какие этапы работают хорошо,</li>
      <li>выявление "слабых мест", где теряются клиенты.</li>
    </ul>
    Фильтр "Дата создания" отбирает сделки по дате создания и показывает, на каком этапе они сейчас.
  `
  },
  managerConersion: {
    title: 'Отчет по работе менеджера',
    html: `
    Показывает воронку продаж по конкретному исполнителю: сколько сделок дошло до каждого этапа и какой процент перехода между ними.
    <br /><br />
    Финальный процент успешных сделок рассчитывается относительно входящих заявок менеджера.
    <br /><br />
    Доступна фильтрация по дате, чтобы оценить эффективность за нужный период.
  `
  },
  conversionRejected: {
    title: 'Процент отказов',
    html: `
    Показывает, какой процент от всех входящих заявок за выбранный период был завершён со статусом отказа.
    <br /><br />
    Учитываются все сделки которые находятся в колонке «❌ Отказы».
    <br /><br />
    Можно фильтровать по дате и исполнителю.
  `
  },
  conversionSucceed: {
    title: 'Процент успешных сделок',
    html: `
    Показывает, какой процент от всех входящих заявок за выбранный период был завершён с успешным статусом.
    <br /><br />
    Учитываются все сделки которые находятся в колонке «✅ Успешные».
  `
  }
}
